import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import NotificationAlert from "react-notification-alert";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import TextField from '@material-ui/core/TextField';
// import Button from '@material-ui/core/Button';
import { Button, Checkbox } from '@material-ui/core';
import Axios from 'axios';
import { API_CONFIG } from "../../../config/config.jsx";
import OperatingHours from "../OperatingHours/OperatingHours.jsx"
import Secure from '../../../components/Secure.jsx';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText'
import Select from '@material-ui/core/Select';
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = theme => ({
  textField: {
    width: "200px",
    marginTop:'-5px',
  },
});

export class CreateUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // name: '',
      // email:'',
      // password:'',
      // mobileNo: '',
      // userType:'',
      // countryCode:'',
      // rolesData:[],

      name: this.props.userData !== '' ? this.props.userData.username : '',
      email:this.props.userData !== ''? this.props.userData.email : '',
      password:this.props.userData !== ''? this.props.userData.password : '',
      mobileNo: this.props.userData !== ''? this.props.userData.mobile : '',
      userType:this.props.userData !== ''? this.props.userData.userType : '',
    //  countryCode: this.props.userData && this.props.userData.country ? this.props.userData.country.countryCode : '',

      // countryCode:'',
      rolesData:[],
      hasError: {
        hascountry:false,
        hasRole:false
      },
      isButtonDisabled: false
    };
    // this.autocompleteInput = React.createRef();
    // this.autocomplete = null;
    // this.handlePlaceChanged = this.handlePlaceChanged.bind(this);
  }
  componentDidMount() {
    console.log('this.props.userData--------------', this.props.userData);
    this.getRoles();
  }
  getRoles = () => {
    this.setState({ isLoading: true });
    const token = sessionStorage.getItem("plugoAuthKey");
    const userId = sessionStorage.getItem("plugoUserId");
    Axios.get(`${API_CONFIG.HOST}/role`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-USER-ID": userId,
      },
    })
      .then((res) => {
        console.log('ressss',res);
        this.setState({
          rolesData: res.data,
        });
      })
      .catch((error) => {
        this.setState({
          rolesData:[],
        }); 
      });
  };
  handleChange = name => event => {
    console.log('name', name);
    console.log('event.target.value', event.target.value);
    this.setState({
      [name]: event.target.value,
    });
  };
  change = (event) => {
    this.setState({
      mobileNo: event.target.value,
      // isEnableMobileNumber: true,
    });
  }
  submit = event => {
    console.log('event ', event);
    event.preventDefault();
    this.setState({
      isButtonDisabled: true,
      hasError:{
hasRole:!this.state.userType,
//hascountry:!this.state.countryCode
      } 
    });
   
    const createUserData ={
      username: this.state.name,
      mobile: this.state.mobileNo,

     // countryCode: this.state.countryCode,
      userType:this.state.userType,
      password:this.state.password,
      email:this.state.email,
    }
    console.log(createUserData);
    const token = sessionStorage.getItem('plugoAuthKey');
    const userId = sessionStorage.getItem('plugoUserId');
    Axios.post(`${API_CONFIG.HOST}/user`, createUserData, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "X-USER-ID": userId
      }
    })
      .then(res => {
        console.log(res);
        this.setState({
          name: '',
          mobileNo: '',
          countryCode: '',
          userType:'',
          isButtonDisabled:false
        })
        
        var options = {
          place: 'tc',
          message: " " + "Created Successfully",
          type: 'success',
          icon: 'far fa-check-circle',
          autoDismiss: 4
        }
        if (this.notification && this.notification.state.notifyTR.length < 1) {
          this.notification.notificationAlert(options)
        }
        this.props.handleCancel();
      })
      .catch(error => {
        this.setState({ isButtonDisabled:false})
        const options = {
          place: 'tc',
          message: `  ${error.response ? error.response.data.message : 'Something went wrong'}`,
          type: 'danger',
          icon: 'fas fa-exclamation-triangle',
          autoDismiss: 4
        }
        if (this.notification && this.notification.state.notifyTR.length < 1) {
          this.notification.notificationAlert(options)
        }
      })

  };

  update = event => {
    console.log('updatee ');
    event.preventDefault();
    this.setState({
      isButtonDisabled: true,
      hasError:{
hasRole:!this.state.userType,
hascountry:!this.state.countryCode
      } 
    });
   
    const createUserData ={
      username: this.state.name,
      mobile: this.state.mobileNo,
      email:this.state.email,
      // country: 'Netherlands'
     // country: this.state.countryCode,
      userType:this.state.userType,
      // password:this.state.password,
    }
    console.log(createUserData);
    const token = sessionStorage.getItem('plugoAuthKey');
    console.log('tokennnnnnnnnnnnnnn',token);
    const userId = sessionStorage.getItem('plugoUserId');
    console.log('userId', userId);
    console.log('this.props.userData',this.props.userData);
    Axios.put(`${API_CONFIG.HOST}/user/update/${this.props.userData.id}`, createUserData, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "X-USER-ID": userId
      }
    })
      .then(res => {
        console.log("updatedddd res",res);
        // this.setState({
        //   name: '',
        //   mobileNo: '',
        //   countryCode: '',
        //   userType:'',
        //   isButtonDisabled:false
        // })
        
        var options = {
          place: 'tc',
          message: " " + "updated Successfully",
          type: 'success',
          icon: 'far fa-check-circle',
          autoDismiss: 4
        }
        if (this.notification ) {
          console.log('notification1111111');
          this.notification.notificationAlert(options)
        }
        this.props.handleCancel();
      })
      .catch(error => {
        console.log("erorrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr",error);
        this.setState({ isButtonDisabled:false})
        const options = {
          place: 'tc',
          message: `  ${error.response ? error.response.data.message : 'Something went wrong'}`,
          type: 'danger',
          icon: 'fas fa-exclamation-triangle',
          autoDismiss: 4
        }
        if (this.notification && this.notification.state.notifyTR.length < 1) {
          this.notification.notificationAlert(options)
        }
      })

  };

  render() {
    const { classes, userData } = this.props;
    console.log('userData propsss', userData);
    console.log({dataaaa: {username: this.state.name,
      mobile: this.state.mobileNo,
    //  countryCode: this.state.countryCode,
      userType:this.state.userType,
      password:this.state.password,
      email:this.state.email,}});
    return (
      <div>
        <div className="rna-container">
        <NotificationAlert ref={(c) => { this.notification = c }} />
        </div>
        <Card>
          {/* <div style={{ width: "80%", border: "1px #A9A9A9 solid", height: "35px", paddingLeft: "8px" }}>
            <i class="fa fa-search" aria-hidden="true"></i>
            <input ref={this.autocompleteInput} id="autocomplete" style={{ width: "97%", border: "none", marginTop: "4px", marginLeft: "4px" }} placeholder="Search Store for autocomplete..."
              type="text">
            </input>
          </div> */}
          <CardBody>
            <form className={classes.container} onSubmit={this.props.userData.username ? this.update :this.submit}>
              <GridContainer rowSpacing={5} >
                <GridItem xs={12} sm={12} md={6} lg={3}>
                  <TextField
                    required
                    id="outlined-name"
                    label="Name"
                    // className={classes.textField}
                    margin="normal"
                    value={this.state.name}
                    onChange={this.handleChange("name")}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6} lg={3}>
                  <TextField
                    req
                    id="outlined-email"
                    label="Email"
                    value={this.state.email}
                    type="email"
                    name="email"
                    autoComplete="email"
                    // className={classes.textField}
                    margin="normal"
                    onChange={this.handleChange("email")}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6} lg={3}>
                  <TextField
                    req
                    id="password"
                    name="password"
                    // type="password"
                    label="Password"
                    value={this.state.password}
                    // className={classes.textField}
                    margin="normal"
                    onChange={this.handleChange("password")}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={6} lg={3}>
                  <TextField
                    required
                    id="outlined-mobileNo"
                    label="Mobile No"
                    value={this.state.mobileNo}
                    onChange={this.change}
                    type="tel"
                    maxlength={15}
                    placeholder="+91 1254631222"
                    pattern="[0-9]{2}-[0-9]{10}"
                    inputProps={{ inputMode: "numeric" }}
                    // className={classes.textField}
                    margin="normal"
                  />
                </GridItem>
               
              </GridContainer>
              <GridContainer>
                {/* <GridItem xs={12} sm={12} md={6} lg={3}>
                  <div>
                    <FormControl
                      style={{ marginTop: "9px", minWidth: 120 }}
                      error={this.state.hasError.hascountry}
                    >
                      <InputLabel id="demo-select-small">
                        Country{" "}
                      </InputLabel>
                      <Select
                        required
                        labelId="demo-select-small"
                        id="outlined-country"
                        className={classes.textField}
                        label="Country"
                        name="countryCode"
                        value={this.state.countryCode}
                        onChange={this.handleChange("countryCode")}
                      >
                        <MenuItem value={"NL"}>Netherlands</MenuItem>
                        <MenuItem value={"CH"}>Switzerland</MenuItem>
                        <MenuItem value={"DE"}>Germany</MenuItem>
                      </Select>
                      {this.state.hasError.hascountry && (
                        <FormHelperText>This is required!</FormHelperText>
                      )}
                    </FormControl>
                  </div>
                </GridItem> */}

                <GridItem xs={12} sm={12} md={6} lg={3}>
                  <div>
                    <FormControl
                      style={{ marginTop: "9px", minWidth: 120 }}
                      error={this.state.hasError.hasRole}
                    >
                      <InputLabel id="demo-select-small">
                        User Type{" "}
                      </InputLabel>
                      <Select
                        required
                        labelId="demo-select-small"
                        id="outlined-userType"
                        className={classes.textField}
                        label="userType"
                        name="userType"
                        onChange={this.handleChange("userType")}
                      >
                        {this.state.rolesData.map((item) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                      </Select>
                      {this.state.hasError.hasRole && (
                        <FormHelperText>This is required!</FormHelperText>
                      )}
                    </FormControl>
                  </div>
                </GridItem>
              </GridContainer>
              
              <div style={{ marginTop: "20px" }}>
                <div style={{ display: "flex", columnGap: "14px" }}>
                  <Button
                    type="submit"
                    disabled={this.state.isButtonDisabled}
                    variant="contained"
                    color="primary"
                  >
                    {this.props.userData.username ? 'Update' :'Create'}
                  </Button>
                  <Button
                    onClick={this.props.handleCancel}
                    disabled={this.state.isButtonDisabled}
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </form>
          </CardBody>
        </Card>
        {this.state.showTime
          ? Secure(
              "CREATE_USERS",
              <OperatingHours
                storeId={this.state.storeId}
                operatingHours={this.state.timing}
                timingText={this.state.timingText}
              />
            )
          : ""}
      </div>
    );
  }
}
CreateUser.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(CreateUser);
